import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import SearchResults from './pages/SearchResults/SearchResults';
import ResourceDetail from './pages/ResourceDetail/ResourceDetail';
import TagsList from './pages/TagsList/TagsList';
// import Docs from './pages/Docs/Docs';
import Profile from './pages/Profile/Profile';
import Checkin from './pages/Checkin/Checkin';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import InviteHandler from './pages/Auth/InviteHandler';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/resource/:id" element={<ResourceDetail />} />
              <Route path="/tags" element={<TagsList />} />
              {/* <Route path="/docs" element={<Docs />} /> */}
              <Route path="/profile" element={<Profile />} />
              <Route path="/checkin" element={<Checkin />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/invite" element={<InviteHandler />} />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;